import assign from "lodash/fp/assign";
import apis from "../../core/apis.js";

class RideResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.ride).get(options);
  }

  get(id) {
    return this.$resource(apis.ride + id).get();
  }

  search(query = "", params) {
    return this.$resource(apis.ride + "autocomplete/").get(
      assign(params, { query })
    );
  }

  post(item) {
    return this.$resource(apis.ride).save(item);
  }

  updateAction(id, name, item) {
    return this.$resource(apis.ride + id + `/${name}`).save(item);
  }

  update(id, item) {
    return this.$resource(apis.ride + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  cancel(id, items) {
    return this.$resource(apis.ride + id + "/cancel").save(items);
  }
  createManualRide(id, data) {
    return this.$resource(apis.ride + id + "/cancel_create_manual_ride").save(
      data
    );
  }
  arrived(id, station) {
    return this.$resource(apis.ride + id + "/arrive_station").save({ station });
  }

  changeBustype(id, bustype) {
    return this.$resource(apis.ride + id + "/change_bus_type").save(bustype);
  }

  assignBus(id, bus) {
    return this.$resource(apis.ride + id + "/assign_bus").save(bus);
  }

  changeDate(id, date) {
    return this.$resource(apis.ride + id + "/change_date").save(date);
  }

  rideType(id, data) {
    return this.$resource(apis.ride + id + "/change_type").save(data);
  }
  lockDynamicRide(id) {
    return this.$resource(apis.dynamicRide + id + "/lock", null, {
      update: { method: "PATCH" },
    }).update();
  }

  captainPrice(id, data) {
    return this.$resource(apis.ride + id + "/set_captain_price").save(data);
  }

  arriavalAllowance(id, data) {
    return this.$resource(
      apis.ride + id + "/change_arrival_time_allowance"
    ).save(data);
  }

  departureAllowance(id, data) {
    return this.$resource(
      apis.ride + id + "/change_departure_time_allowance"
    ).save(data);
  }

  assignCaptain(id, items) {
    return this.$resource(apis.ride + id + "/assign_captain").save(items);
  }

  assignVendor(id, items) {
    return this.$resource(apis.ride + id + "/assign_vendor").save({
      vendor_id: items.vendor,
      vendor_type: items.type,
      reason: items.reason,
    });
  }

  unAssignCaptain(id, items) {
    return this.$resource(apis.ride + id + "/unassign").save(items);
  }
  setPrice(id, captain) {
    return this.$resource(apis.ride + id + "/set_captain_price").save(captain);
  }

  assignBackup(id, backup) {
    return this.$resource(apis.ride + id + "/assign_backup").save(backup);
  }

  departed(id, station) {
    const data = station ? { station } : null;

    return this.$resource(apis.ride + id + "/depart_station").save(data);
  }

  seatsToMax(id) {
    return this.$resource(apis.ride + id + "/seats_to_maximum").save();
  }

  emergency(id) {
    return this.$resource(apis.ride + id + "/mark_emergency").save();
  }

  unmarkEmergency(id) {
    return this.$resource(apis.ride + id + "/unmark_emergency").save();
  }

  end(id) {
    return this.$resource(apis.ride + id + "/end").save();
  }

  enable(id) {
    return this.$resource(apis.ride + id + "/enable_bookings").save();
  }

  disable(id) {
    return this.$resource(apis.ride + id + "/disable_bookings").save();
  }

  extraSeat(id) {
    return this.$resource(apis.ride + id + "/add_extra_seat").save();
  }

  dailyCount() {
    return this.$resource(apis.ride + "count/daily").get();
  }

  weeklyCount() {
    return this.$resource(apis.ride + "count/weekly").get();
  }

  monthlyCount() {
    return this.$resource(apis.ride + "count/monthly").get();
  }

  dailyUtilization() {
    return this.$resource(apis.ride + "utilization/daily").get();
  }

  weeklyUtilization() {
    return this.$resource(apis.ride + "utilization/weekly").get();
  }

  monthlyUtilization() {
    return this.$resource(apis.ride + "utilization/monthly").get();
  }

  punctuality(data) {
    return this.$resource(apis.ride + "punctulaity").get(data);
  }

  cashCollection(id) {
    return this.$resource(apis.ride + `${id}/cash_collection`).get();
  }

  transferSuggestions(id) {
    return this.$resource(apis.ride + `${id}/transfer_suggestions`).get();
  }

  transferBookings(id, data) {
    return this.$resource(apis.ride + `${id}/transfer_bookings`).save(data);
  }
  checkTransferAvailability(data) {
    return this.$resource(apis.ride + "transfer_availability_check").save(data);
  }

  skipStation(id) {
    return this.$resource(apis.ride + id + "/skip_station").save();
  }

  analyseBackup(data) {
    this.$resource(apis.analyseBackup).save(data);
  }
}

export default RideResource;



// WEBPACK FOOTER //
// ./src/resources/ride/ride.resource.js